import styled from 'styled-components';
import tw, { classnames, textColor, position, padding } from 'tailwindcss-classnames';

export const Container = styled.div.attrs({
    className: classnames(position('relative'), padding('pb-0', 'lg:pb-1', 'px-0'))
})``;

export const Subtitle = (color: string) =>  styled.p.attrs({
    className: classnames(textColor(color as any), position('relative'))
})`
    font-size: 1.1rem;
    font-weight: 200;
`;
